import { CSSProperties } from 'react';

/**
 * MatchReasonCard — compact --surface card pairing a short serif claim with a
 * quiet sans explanation ("Why Alma paired you" stack on the host profile).
 */
export interface MatchReasonCardProps {
  /** Serif headline, e.g. "Depth over breadth". */
  title: string;
  /** Sans explanation under it. */
  text?: string;
  style?: CSSProperties;
}

export function MatchReasonCard({ title, text, style }: MatchReasonCardProps) {
  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 10, padding: '12px 14px', fontFamily: 'var(--font-sans)', ...style }}>
      <div style={{ fontFamily: 'var(--font-serif)', fontSize: 'var(--fs-footnote)', fontWeight: 400, color: 'var(--text)', marginBottom: 3 }}>{title}</div>
      {text ? <span style={{ fontSize: 'var(--fs-caption)', color: 'var(--text-soft)', lineHeight: 1.55 }}>{text}</span> : null}
    </div>
  );
}

export default MatchReasonCard;
